import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default defineNuxtPlugin(() => {
	gsap.registerPlugin(ScrollTrigger)

	gsap.config({
		autoSleep: 80,
		force3D: false,
		nullTargetWarn: false,
		units: {
			left: '%',
			top: '%',
			rotation: 'rad'
		}
	})

	ScrollTrigger.defaults({
		toggleActions: 'play none none none',
		scrub: false,
		pin: false,
		markers: false,
		invalidateOnRefresh: true,
	})
})
